import { useId } from 'react';

import { Text } from '@change/ds-core-ui/Text';
import { Checkbox } from '@change/ds-forms/Checkbox';

import { useI18n } from '@change-corgi/core-react/i18n';

export const VideoConsentCheckbox: React.FC<VideoConsentCheckboxProps> = ({
	isSelected,
	onChange,
	className,
	description,
}) => {
	const { translate } = useI18n();
	const descriptionId = useId();
	const label = translate('corgi.social_starter_shared.claim.video_consent_label');

	return (
		<Checkbox
			name="video-consent"
			isSelected={isSelected}
			onChange={onChange}
			data-qa="video-consent-checkbox"
			aria-label={label}
			aria-describedby={descriptionId}
			className={className}
		>
			<div>
				<Text variant="body" as="p" className="text-typography-strong">
					{label}
				</Text>
				<Text variant="body" size="small" className="text-typography-weak" as="p" id={descriptionId}>
					{description ?? translate('corgi.social_starter_shared.claim.video_consent_description')}
				</Text>
			</div>
		</Checkbox>
	);
};

type VideoConsentCheckboxProps = {
	isSelected: boolean;
	onChange: (isSelected: boolean) => void;
	className?: string;
	description?: string;
};
